<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
       <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 신한은행과
                                퇴직연금고객 교육솔루션 MOU 체결</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                        <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_03.png"></figure>
                                <br>
                                <br>
                                종합교육기업 에듀윌이 신한은행과 신한은행 퇴직연금 가입 고객들에게 맞춤형 교육 서비스 제공을 위한 공동 양해각서(MOU)를 체결했다고 24일 밝혔다.
                                <br><br>
                                에듀윌은 회원수 380만명의 취업/자격증 분야 선도 기업으로 차별화된 전문 자격증 강의와 창업 아카데미 운영 등 실질적인 교육 솔루션을 제공하는 교육기업이다.
                                <br><br>
                                에듀윌은 24일부터 신한은행 퇴직연금 가입고객 전용 온라인 교육몰을 개설해 공인중개사, 전기기사 등의 자격증 과정과 부동산 아카데미와 같은 교육서비스 등 총
                                35개의 과정을 제공할 예정이다.
                                <br><br>
                                신한은행 퇴직연금 가입고객들은 전용 온라인 교육몰에서 할인된 특별가로 강의를 이용할 수 있으며 퇴직연금 가입고객 중 은퇴한 고객들의 재취업을 준비하는 일에도
                                도움이 될 수 있는 강의들을 준비했다.
                                <br><br>
                                에듀윌 대표는 "신한은행 퇴직연금 가입 고객들의 자기계발 및 재취업에 도움을 줄 수 있어 매우 기쁘게 생각한다"며 "이번 교육몰 오픈을 기점으로 퇴직 예정
                                고객들의 자기계발에 더 많은 지원을 할 수 있도록 준비할 것"이라고 밝혔다.
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news2" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 코로나 시대 공기업 및 대기업 취업 화상교육 진행</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                                <!-- 다음 보도 기사가 있을 경우 -->
                                <li class="next">
                                    <router-link to="/edu/newsRelease/promotionVideo/news4" data-value="315284">
                                        <strong>다음</strong>
                                        <span>에듀윌, 전국 대학교에 공무원 및 취업 정보지 무료 배포 진행</span>
                                    </router-link>
                                </li>
                                <!-- //다음 보도 기사가 있을 경우 -->
                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
